import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';
import { env } from '../env'
export const APP_NAME = 'TAS-Q';
export const API_BASE_URL = env.apiUrl + '/api';
//export const API_BASE_URL = 'http://localhost:3002/api';
//export const API_BASE_URL = 'https://api.tas-q.com/api';
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: 'en',
	navType: NAV_TYPE_SIDE,
	topNavColor: '#0099A8',
	headerNavColor: '',
	mobileNav: false,
	currentTheme: 'light',
	direction: DIR_LTR
};
